// src/lib/kinema/devtools/DevTools.tsx
import { useState } from 'react';
import { LayerTreePanel } from './LayerTreePanel';
import { CommandLogPanel } from './CommandLogPanel';
import { StateInspector } from './StateInspector';
import { ExportPanel } from './ExportPanel';

type Tab = 'tree' | 'commands' | 'state' | 'export';

interface DevToolsProps {
  position?: 'bottom' | 'right';
  defaultOpen?: boolean;
}

export function DevTools({ defaultOpen = false }: DevToolsProps) {
  const [open, setOpen] = useState(defaultOpen);
  const [activeTab, setActiveTab] = useState<Tab>('tree');

  const tabs: { key: Tab; label: string }[] = [
    { key: 'tree', label: 'Layer Tree' },
    { key: 'commands', label: 'Commands' },
    { key: 'state', label: 'Inspector' },
    { key: 'export', label: 'Export' },
  ];

  return (
    <div style={{
      gridColumn: '1 / -1',
      background: '#ffffff',
      borderTop: '1px solid #e2e8f0',
      fontFamily: 'system-ui, sans-serif',
      height: open ? 220 : 28,
      minHeight: 28,
      overflow: 'hidden',
      transition: 'height 0.15s ease',
    }}>
      <div style={{ display: 'flex', borderBottom: '1px solid #e2e8f0', height: 28, alignItems: 'center', background: '#f8fafc' }}>
        <button
          onClick={() => setOpen(!open)}
          style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', padding: '0 8px', fontSize: 12, fontWeight: 600 }}
        >
          {open ? '\u25BC' : '\u25B2'} DevTools
        </button>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => { setActiveTab(tab.key); if (!open) setOpen(true); }}
            style={{
              background: activeTab === tab.key && open ? '#ffffff' : 'transparent',
              border: 'none',
              color: activeTab === tab.key ? '#2563eb' : '#94a3b8',
              cursor: 'pointer',
              padding: '4px 12px',
              fontSize: 11,
              fontWeight: activeTab === tab.key ? 600 : 400,
              borderBottom: activeTab === tab.key && open ? '2px solid #2563eb' : '2px solid transparent',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {open && (
        <div style={{ height: 'calc(100% - 28px)', overflow: 'auto' }}>
          <div style={{ display: activeTab === 'tree' ? 'block' : 'none', height: '100%', overflow: 'auto' }}>
            <LayerTreePanel />
          </div>
          <div style={{ display: activeTab === 'commands' ? 'block' : 'none', height: '100%', overflow: 'auto' }}>
            <CommandLogPanel />
          </div>
          <div style={{ display: activeTab === 'state' ? 'block' : 'none', height: '100%', overflow: 'auto' }}>
            <StateInspector />
          </div>
          <div style={{ display: activeTab === 'export' ? 'block' : 'none', height: '100%', overflow: 'auto' }}>
            <ExportPanel />
          </div>
        </div>
      )}
    </div>
  );
}
